import { config } from "core/config/app";
import FavoritePage from "./pages/FavoritePage";

const router = [
  {
    name: "FAVORITES",
    auth: true,
    exact: true,
    path: `${config?.basename}/favorites`,
    element: <FavoritePage />,
    title: "Favorites",
  },
];
export default router;
